<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
               [isReadOnly]="isReadOnly"
               [labelText]="labelText"
               [labelMode]="labelMode"
               [title]="title"
               [code]="code"
               [validationRules]="validationRulesMap" [validationV2]="validationV2"
               (handleValueChange)="handleValueChange($event)"
               (codeChanges)="code = $event"
               (searchClick)="searchClick()"
               [labelWidth]="labelWidth"
               (clear)="clear()"
               [isReadonlyViewBtn]="isReadonlyViewBtn"
                [warningMessage]="warningMessage"
               [isShowViewBtn]="isShowViewBtn" (viewBtnClick)="viewButtonlick($event)"
>
</dk-ctl-sablon>
<dx-popup
  *ngIf="crudPopupVisible"
  title="Hesap Arama"
  [resizeEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="crudPopupVisible"
  (onHiding)="closePopupAfter($event, sablonCmp)"
>
  <dk-ctl-tem-hesap-arama
    [control]="control"
    [filterColumn]="filterColumn"
    [filterColumnValue]="filterColumnValue"
    (closePopup)="closePopupAfter($event, sablonCmp)"
  ></dk-ctl-tem-hesap-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage">
</dx-toast>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
